export const DEFAULT_INTEREST_RATE = 7.45;
export const DEFAULT_SETUP_FEE = 588;
export const DEFAULT_INVOICE_FEE = 59;
export const DEFAULT_CASH_DEPOSIT = 20;
export const DEFAULT_SALVAGE_AMOUNT = 55;
export const DEFAULT_MONTHS = 36;
